// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { FACEBOOK } from '@/lib/socialProfile';
import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementRateHistoryConfig = {
    title: 'chart.facebook.avg_engagement_rate_history',
    tooltip: 'chart.facebook.tooltip_avg_engagement_rate_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        engagement_rate: 'chart.facebook.avg_engagement_rate_history_name',
        engagement_rate_followers: 'chart.facebook.avg_engagement_rate_followers_history_name'
    },
    disableGraphData: ['count_posts'],
    id: 'average_engagement_rate_history',
    social: FACEBOOK,
    color: {
        engagement_rate: 'green',
        engagement_rate_followers: 'blue'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    size: SIZE_50,
    type: 'chart',
    element: LineChart
};
